import { c as _c } from "react/compiler-runtime";
import { GrowthBook, GrowthBookProvider } from '@growthbook/growthbook-react';
import { PropsWithChildren, useEffect } from 'react';
import useUser from 'shared/hooks/use-user';
export const growthbookClient = new GrowthBook({
  clientKey: process.env.NEXT_PUBLIC_GROWTHBOOK_CLIENT_KEY,
  enableDevMode: process.env.NODE_ENV === 'development'
});
interface GrowthbookClientProviderProps extends PropsWithChildren {
  currentPath: string;
}
export function GrowthbookClientProvider(t0) {
  const $ = _c(8);
  const {
    children,
    currentPath
  } = t0;
  const {
    user
  } = useUser();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  useEffect(_temp, t1);
  let t2;
  if ($[1] !== currentPath) {
    t2 = [currentPath];
    $[1] = currentPath;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  useEffect(_temp2, t2);
  let t3;
  let t4;
  if ($[3] !== user) {
    t3 = () => {
      if (!user) {
        return;
      }
      growthbookClient.setAttributes({
        id: user.id,
        roles: user.roles,
        userPlanId: user.userPlanId,
        country: user.country
      });
    };
    t4 = [user];
    $[3] = user;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  useEffect(t3, t4);
  let t5;
  if ($[6] !== children) {
    t5 = <GrowthBookProvider growthbook={growthbookClient}>{children}</GrowthBookProvider>;
    $[6] = children;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
}
function _temp2() {
  growthbookClient.setURL(window.location.href);
}
function _temp() {
  growthbookClient.init({
    skipCache: true,
    streaming: true
  });
}